<div class="app-form-field app-ui">

   <div class="app-label" *ngIf="_labelChildNonStatic || _hintChild">
      <ng-content select="app-label"></ng-content>
      <ng-content select="app-hint"></ng-content>

   </div>


</div>